const DASHBOARD_VIEW_OPTIONS = [
    { value: 'Collector View', label: 'Collector View' },
    { value: 'Collections Manager View', label: 'Collections Manager View' },
];

const PERMISSION_META_KEYS = new Set([
    'UserName',
    'userName',
    'ModifiedBy',
    'ModifiedOn',
    'IsKeyMachineAdmin',
]);

/** Matches the legacy Login & Permission tab: Navigation Items + Submenus */
const PERMISSION_MODULES = [
    {
        id: 'inventory',
        title: 'Inventory',
        navKey: 'NV_Inventory',
        permissions: [
            { key: 'Inv_Add', label: 'Add Vehicle' },
            { key: 'Inv_Edit', label: 'Edit Vehicle & Customize List Page' },
            { key: 'Inv_Del', label: 'Delete Vehicle' },
            { key: 'Inv_Flag', label: 'Flags' },
            { key: 'Inv_Cost', label: 'Show Cost' },
            { key: 'Inv_AddEditPurchasedFrom', label: 'Add/Edit Purchased From' },
            { key: 'Inv_ChangeLot', label: 'Change Lot Name' },
            { key: 'Inv_AddRemoveTag', label: 'Add/Remove Tag' },
            { key: 'Inv_MarketComps', label: 'Market Comps' },
            { key: 'Inv_Appraisals', label: 'Appraisals' },
            { key: 'Inv_EditNotes', label: 'Edit Notes' },
        ],
    },
    {
        id: 'deals',
        title: 'Deals',
        navKey: 'NV_Sales',
        permissions: [
            { key: 'Sales_Add', label: 'Add Deal' },
            { key: 'Sales_Edit', label: 'Edit Deal' },
            { key: 'Sales_FullEdit', label: 'Full Deal Editing' },
            { key: 'Sales_Del', label: 'Delete Deal' },
            { key: 'Sales_Trans', label: 'Transfer' },
            { key: 'Sales_Fund', label: 'Funding' },
            { key: 'Sales_Flag', label: 'Flags' },
            { key: 'Sales_Approval', label: 'Deals Approval' },
            { key: 'Sales_Restore_Deleted', label: 'Restore Deleted Deal' },
            { key: 'Sales_ChangeLot', label: 'Change Lot Name' },
            { key: 'Sales_SendToTagAgency', label: 'Send to Tag Agency' },
            { key: 'Sales_MenuContracts', label: 'F&I Menu Contracts' },
            { key: 'Sales_MenuSettingsLogs', label: 'F&I Menu Settings/Logs' },
            { key: 'Sales_MenuDealerCost', label: 'Dealer Cost Menu' },
            { key: 'DealerTrack', label: 'Dealer Track' },
            { key: 'Sales_ShowWashout', label: 'Show Washout' },
            { key: 'Sales_ChangeSoldDate', label: 'Change Sold Date' },
            { key: 'Sales_ChangeFinanceManager', label: 'Change Finance Manager' },
            { key: 'Sales_OverrideCommissions', label: 'Override Commissions' },
            { key: 'Sales_DeleteDocument', label: 'Delete Deal Documents' },
            { key: 'Sales_CreditPull', label: 'Credit Pull' },
        ],
    },
    {
        id: 'dashboard',
        title: 'Dashboard',
        navKey: 'NV_Dashboard',
        permissions: [
            { key: 'Dashboard_PartsList', label: 'Parts List' },
            { key: 'Dashboard_ReconApproval', label: 'Recon Approval' },
        ],
    },
    {
        id: 'desking',
        title: 'Desking Tools',
        navKey: 'NV_Desking',
        permissions: [],
    },
    {
        id: 'bhph',
        title: 'BHPH',
        navKey: 'NV_Payments',
        permissions: [
            { key: 'Pay_Add', label: 'Take Payment' },
            { key: 'Pay_Edit', label: 'Edit Payment' },
            { key: 'Pay_Del', label: 'Delete Payment' },
            { key: 'BHPH_AllowReversePayment', label: 'Reverse Payment' },
            { key: 'BHPH_EditPtp', label: 'Edit PTP' },
            { key: 'BHPH_CancelPtp', label: 'Cancel PTP' },
            { key: 'BHPH_EditEmailContent', label: 'Communication - Edit Email Content' },
            { key: 'BHPH_SetRunTimeForScheduledPayments', label: 'Can Set Run Time for Scheduled Payments' },
            { key: 'BHPH_Portfolio_Change', label: 'Portfolio - Change' },
            { key: 'BHPH_ServicingBranch_Change', label: 'Servicing Branch - Change' },
            { key: 'BHPH_ForceReQueue', label: 'Allow Force Re-queue' },
            { key: 'BHPH_AddRemoveTag', label: 'Add/Remove Tag' },
            { key: 'BHPH_AllowRefinance', label: 'Allow Refinance' },
            { key: 'BHPH_AllowOFR', label: 'Allow OFR' },
            { key: 'BHPH_AllowChargeOff', label: 'Allow Charge Off' },
            { key: 'BHPH_ReverseChargeOff', label: 'Reverse Charge Off' },
        ],
    },
    {
        id: 'crm',
        title: 'CRM',
        navKey: 'NV_CRM',
        permissions: [
            { key: 'Cust_Add', label: 'Add Customer' },
            { key: 'Cust_Edit', label: 'Edit Customer' },
            { key: 'Cust_Del', label: 'Delete Customer' },
            { key: 'Cust_Flag', label: 'Flags' },
            { key: 'Cust_Circle', label: 'Circles' },
            { key: 'CRM_RecordManager', label: 'Allow to change Rec. Manager' },
            { key: 'CRM_Salesman', label: 'Allow to change Salesman' },
            { key: 'CRM_LostLead', label: 'Allow to check lost Lead' },
            { key: 'CRM_NewLead', label: 'Allow to check new Lead' },
            { key: 'CRM_Emails_SMS', label: 'Add/Edit Message Templates' },
            { key: 'CRM_DuplicateLead', label: 'Allow Duplicate' },
            { key: 'CRM_AllLead', label: 'All lead access' },
            { key: 'CRM_AllLotsLead', label: 'All lots lead access' },
            { key: 'CRM_AddEditTags', label: 'Add/Edit Tag' },
            { key: 'CRM_CreditPull', label: 'Credit Pull' },
            { key: 'CRM_CustomerMerge', label: 'Allow Customer Merge' },
        ],
    },
    {
        id: 'hr',
        title: 'HR',
        navKey: 'NV_HR',
        permissions: [
            { key: 'Set_User', label: 'Employee Info' },
            { key: 'HR_Setting', label: 'HR Settings' },
            { key: 'HR_Delete', label: 'Delete' },
            { key: 'HR_Calendar', label: 'Calendar' },
            { key: 'HR_PayInfo', label: 'Pay Information' },
            { key: 'HR_EditWorkScheduleAll', label: 'Edit All Work Schedule' },
            { key: 'HR_EditWorkSchedule', label: 'Edit Work Schedule' },
            { key: 'HR_LogIn_Permissions_Tab', label: 'Permissions' },
            { key: 'HR_RevealSensitiveData', label: 'Reveal Sensitive Data' },
        ],
    },
    {
        id: 'payroll',
        title: 'Payroll',
        navKey: null,
        permissions: [
            { key: 'HR_ApproveHours', label: 'Approve Hours' },
            { key: 'HR_ApproveCommissions', label: 'Approve Commissions' },
            { key: 'HR_MarkCommissionsAsPaid', label: 'Mark Commissions as Paid' },
            { key: 'HR_PayrollChecks', label: 'Payroll Checks' },
        ],
    },
    {
        id: 'service',
        title: 'Service',
        navKey: 'NV_Service',
        permissions: [
            { key: 'Service_OpenRO', label: 'Open RO' },
            { key: 'Service_DeleteCust', label: 'Delete Customers' },
            { key: 'Service_EditRO', label: 'Edit RO' },
            { key: 'Service_VoidRO', label: 'Void RO' },
            { key: 'Service_TransferRO', label: 'Transfer RO' },
            { key: 'Service_AddDeleteParts', label: 'Add Parts' },
            { key: 'Service_RemoveParts', label: 'Remove Parts' },
            { key: 'Service_LaborHours', label: 'Labor Hours' },
            { key: 'Service_OverrideLaborRate', label: 'Override Labor Rate' },
            { key: 'Service_OverridePartPrice', label: 'Override Part Price' },
            { key: 'Service_OverrideSubletPrice', label: 'Override Sublet Price' },
            { key: 'Service_Advisor', label: 'Edit Advisor' },
            { key: 'Service_Flag', label: 'Flags' },
            { key: 'Service_ViewOperationCode', label: 'View Operation Codes' },
            { key: 'Service_AddOperationCode', label: 'Add Operation Codes' },
            { key: 'Service_EditOperationCode', label: 'Edit Operation Codes' },
            { key: 'Service_DeleteOperationCode', label: 'Delete Operation Codes' },
        ],
    },
    {
        id: 'parts',
        title: 'Parts',
        navKey: 'NV_Parts',
        permissions: [
            { key: 'Parts_AddPart', label: 'Add Part' },
            { key: 'Parts_EditPart', label: 'Edit Part' },
            { key: 'Parts_NewTicket', label: 'New Ticket' },
            { key: 'Parts_EditTicket', label: 'Edit Ticket' },
            { key: 'Parts_TicketAddDeleteParts', label: 'Add/Delete Parts on Ticket' },
            { key: 'Parts_OverridePartPrice', label: 'Override Part Price' },
            { key: 'Parts_ChangeQuantity', label: 'Change Parts Quantity' },
            { key: 'Parts_Flag', label: 'Flags' },
        ],
    },
    {
        id: 'accounting',
        title: 'Accounting',
        navKey: 'NV_Cashier',
        permissions: [
            { key: 'Cashier_Collect', label: 'Collection and Payouts' },
            { key: 'Cashier_Acct', label: 'Open Balances' },
            { key: 'Cashier_EditTrans', label: 'Edit Transaction' },
            { key: 'Cashier_DelTrans', label: 'Delete Transaction' },
            { key: 'Cashier_AssignTrans', label: 'Assign Transaction' },
            { key: 'Accounting_Receivable', label: 'Receivable' },
            { key: 'Accounting_Payable', label: 'Payable' },
            { key: 'Accounting_Payroll', label: 'Payroll' },
            { key: 'Accounting_Journals', label: 'Journals' },
            { key: 'Accounting_COA', label: 'COA' },
            { key: 'Accounting_Tools', label: 'Tools' },
            { key: 'Accounting_LockDate', label: 'Lock Date' },
            { key: 'Accounting_Banking', label: 'Banking - View' },
            { key: 'Banking_AddCheck', label: 'Banking - Add Check' },
            { key: 'Banking_EditCheck', label: 'Banking - Edit Check' },
            { key: 'Banking_VoidCheck', label: 'Banking - Void Check' },
            { key: 'Banking_PrintCheck', label: 'Banking - Print Check' },
            { key: 'Banking_ReprintCheck', label: 'Banking - Reprint Check' },
            { key: 'Banking_ApproveCheck', label: 'Banking - Approve Check' },
            { key: 'Banking_UnapproveCheck', label: 'Banking - Unapprove Check' },
            { key: 'Banking_AddDeposit', label: 'Banking - Add Deposit' },
            { key: 'Banking_EditDeposit', label: 'Banking - Edit Deposit' },
            { key: 'Banking_VoidDeposit', label: 'Banking - Void Deposit' },
            { key: 'Banking_TransferFund', label: 'Banking - Transfer Fund' },
            { key: 'Banking_ViewEndingBalance', label: 'Banking - View Ending Balance' },
        ],
    },
    {
        id: 'settings',
        title: 'Settings',
        navKey: 'NV_Settings',
        permissions: [
            { key: 'Set_Comp', label: 'Company Info' },
            { key: 'Set_Lots', label: 'Lots' },
            { key: 'Setting_Access_Query', label: 'Access Queries' },
            { key: 'Setting_ManageTasks', label: 'Manage Tasks' },
            { key: 'Setting_Inv_AddTags', label: 'Inventory - Add Tags' },
            { key: 'Setting_Inv_DeleteTags', label: 'Inventory - Delete Tags' },
            { key: 'Setting_BHPH_AddTags', label: 'BHPH - Add Tags' },
            { key: 'Setting_BHPH_DeleteTags', label: 'BHPH - Delete Tags' },
            { key: 'Setting_HomePage', label: 'Home Page' },
            { key: 'Setting_Recon', label: 'Recon' },
            { key: 'Setting_BIAndGoals', label: 'BI and Goals' },
            { key: 'Setting_CRMTags', label: 'CRM - Tags' },
            { key: 'Setting_BHPH_EditContracts', label: 'BHPH - Edit Contracts' },
        ],
    },
    {
        id: 'reports',
        title: 'Reports',
        navKey: 'NV_Reports',
        permissions: [
            { key: 'Reports_Inventory', label: 'Inventory' },
            { key: 'Reports_Deals', label: 'Deals' },
            { key: 'Reports_CRM', label: 'CRM' },
            { key: 'Reports_FNI', label: 'F&I' },
            { key: 'Reports_Accounting', label: 'Accounting' },
            { key: 'Accounting_Financials', label: 'Financials' },
            { key: 'Accounting_BankingTransactions', label: 'Banking Transactions' },
            { key: 'Accounting_CheckingTransactions', label: 'Checking Transactions' },
            { key: 'Reports_BHPH', label: 'BHPH' },
            { key: 'Reports_Service', label: 'Service' },
            { key: 'Reports_Parts', label: 'Parts' },
            { key: 'Reports_Title', label: 'Title' },
            { key: 'Reports_Documents', label: 'Documents' },
            { key: 'Reports_HR', label: 'HR' },
            { key: 'Reports_Payroll', label: 'Payroll' },
        ],
    },
    {
        id: 'creditReporting',
        title: 'Credit Reporting',
        navKey: 'NV_CreditReporting',
        permissions: [
            { key: 'CreditReporting_Edit', label: 'Edit' },
            { key: 'CreditReporting_EditDoNotReport', label: 'Edit Do Not Report' },
            { key: 'CreditReporting_ApproveCreditRun', label: 'Approve Credit Run' },
            { key: 'CreditReporting_DownloadMetro2Files', label: 'Download Metro 2 Files' },
            { key: 'CreditReporting_UnlockCreditRun', label: 'Unlock Credit Run' },
            { key: 'CreditReporting_AccountView', label: 'Account - View' },
            { key: 'CreditReporting_AccountEdit', label: 'Account - Edit' },
            { key: 'CreditReporting_AccountViewHistory', label: 'Account - View History' },
            { key: 'CreditReporting_AccountEditDoNotReport', label: 'Account - Edit Do Not Report' },
            { key: 'CreditReporting_ChangeReportingCompanyOnPortfolio', label: 'Portfolio - Change Credit Reporting Company' },
            { key: 'CreditReporting_CompanySettingView', label: 'View Credit Report Company Setting' },
            { key: 'CreditReporting_CompanySettingEdit', label: 'Edit Credit Report Company Setting' },
            { key: 'CreditReporting_DeleteLastRun', label: 'Delete Last Run' },
        ],
    },
    {
        id: 'recon',
        title: 'Recon',
        navKey: 'NV_Recon',
        permissions: [
            { key: 'Recon_ApproveActivity', label: 'Approval' },
            { key: 'Recon_RepairAssignee', label: 'Repair Assignee' },
        ],
    },
    {
        id: 'bi',
        title: 'Business Intelligence',
        navKey: 'NV_BI',
        permissions: [
            { key: 'BI_Dashboard_View', label: 'Dashboard View' },
            { key: 'BI_Dashboard_Edit', label: 'Dashboard Edit' },
            { key: 'BI_CustomReports_View', label: 'Custom Reports View' },
            { key: 'BI_Rules_View', label: 'Rules View' },
            { key: 'BI_Query_View', label: 'Query View' },
            { key: 'BI_Query_Edit', label: 'Query Edit' },
        ],
    },
    {
        id: 'websiteSettings',
        title: 'Website Settings',
        navKey: null,
        showNavCheckbox: false,
        permissions: [
            { key: 'Website_Settings', label: 'Administrator' },
        ],
    },
    {
        id: 'electronicPayments',
        title: 'Electronic Payments',
        navKey: null,
        showNavCheckbox: false,
        permissions: [
            { key: 'ElectronicPayment_DeletePendingTransactions', label: 'Delete Pending Transactions' },
        ],
    },
    {
        id: 'training',
        title: 'Training',
        navKey: null,
        showNavCheckbox: false,
        permissions: [
            { key: 'Training_ManageCategories', label: 'Manage Categories' },
            { key: 'Training_ManageVideos', label: 'Manage Videos' },
        ],
    },
];

const getModulePermissionKeys = (module) => {
    const keys = module.permissions.map((item) => item.key);
    if (module.navKey) keys.unshift(module.navKey);
    return keys;
};

const getAllCatalogKeys = () => PERMISSION_MODULES.flatMap(getModulePermissionKeys);

const getPermissionModules = () => PERMISSION_MODULES;

const getPermissionValue = (permissions = {}, key) => Boolean(permissions?.[key]);

const isModuleNavChecked = (permissions, module) => {
    if (module.navKey) {
        return getPermissionValue(permissions, module.navKey);
    }
    if (!module.permissions.length) return false;
    return module.permissions.every((item) => getPermissionValue(permissions, item.key));
};

export {
    DASHBOARD_VIEW_OPTIONS,
    PERMISSION_MODULES,
    PERMISSION_META_KEYS,
    getPermissionModules,
    getModulePermissionKeys,
    getAllCatalogKeys,
    getPermissionValue,
    isModuleNavChecked,
};
